module.exports = __webpack_public_path__ + "static/media/doubleDog1.90296fc2.png";